{
	"backToManageDeclarations": "Back to Manage declarations",
	"kpi": {
		"quantity": "Quantity",
		"carbonSavings": "Carbon reductions"
	},
	"downloadAllDeclarations": "Download all declarations",
	"errors": {
		"notFound": "Project not found"
	}
}
